/* eslint-disable no-console */
import { useReducer } from 'react';
import moment from 'moment';

export function capitalizeSentence(str) {
  function setString(acc, letter, index) {
    return index === 0 ? letter.toUpperCase() :  `${acc}${letter.toLowerCase()}` 
  }
  return str && str.split('').reduce(setString, '');
}

export function delay(duration) {
  return new Promise(resolve => setTimeout(resolve, duration));
}

export function formatCommaMakeInteger(number) {
  const wholeNumber = Math.floor(Number.parseInt(number, 10));
  return wholeNumber.toLocaleString('EN');
}

export function formatDateTime(date) {
  return moment(date).format('DD-MMM-YYYY HH:mm');
}

export function getSessionStorageItem({ item }) {
  try {
    const serializedState = sessionStorage.getItem(item);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error(`Could not get ${item}`);
    return undefined;
  }
}

export function getRoleName(role) {
  return role.roleName;
}

export function getOrganisationName(role) {
  return role.orgDescription;
}

export function getTkn(key) {
  try {
    return key === 'apiKey' ? sessionStorage.getItem('v2tkn') : sessionStorage.getItem('v2tkndispatcher');
  } catch (err) {
    console.error('Error getting session storage');
  }
  return null;
}

export function isEmptyObject(obj) {
  return obj && Object.entries(obj).length === 0 && obj.constructor === Object;
}


export function multipleButtonSelect({ e, state, setState }) {
  const {
    target: { name, value },
  } = e;

  if (state.includes(value)) {
    const filteredArray = state.filter(organisation => organisation !== value);
    setState({ [name]: filteredArray });
  } else {
    setState({ [name]: [...state, value] });
  }
}

export function removeSessionStorageItem({ item }) {
  try {
    sessionStorage.removeItem(item);
  } catch (err) {
    console.error(`Could not remove ${item}`);
  }
}

export function roundToOne(num) {
  // eslint-disable-next-line prefer-template
  return +(Math.round(num + 'e+1') + 'e-1');
}

export function roundToTwo(num) {
  // eslint-disable-next-line prefer-template
  return +(Math.round(num + 'e+2') + 'e-2');
}

export function setSessionStorageItem({ key, item }) {
  try {
    const serializedState = JSON.stringify(item);
    sessionStorage.setItem(key, serializedState);
  } catch (err) {
    console.error(`Could not set ${item}`);
  }
}

// Cannot Test Outside of React Component
/* istanbul ignore next */ 
export function useSetState(initialState) {
  function reducer(state, newState) {
    return ({ ...state, ...newState });
  }
  const [state, setState] = useReducer(reducer, initialState);
  return [state, setState];
}

export function validArray(arr) {
  return arr && arr.length > 0;
}